module.exports = __webpack_public_path__ + "img/20190628160846QQ截图20190624162314.297cd44c.png";